import styled from "styled-components";
import { type LayoutProps, layout } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Slider = styled.div`
    position: relative;
    margin-bottom: ${theme.space[2]}px;
    overflow: hidden;
`;

export const SliderViewport = styled.div`
    position: relative;
    width: 100%;
    min-height: calc(230px + 75px);
    margin: 0 auto;
    overflow: hidden;
    &::after {
        display: block;
        padding-bottom: 70%;
        content: "";
    }
`;

type TrackType = { width?: number; position: string; left: number };
export const Track = styled.div.attrs<TrackType>(({ left }) => ({ style: { transform: `translateX(${left}px)` } }))<
    TrackType & LayoutProps
>`
    display: flex;
    position: absolute;
    position: ${({ position }) => position};
    top: 0;
    bottom: 0;
    left: 0;
    flex-direction: row;
    transition:
        opacity 0.3s,
        transform 0.5s;
    z-index: 3;
    ${layout};
`;

export const ImageWrapper = styled.div`
    width: 100%;
`;
export const Image = styled.img`
    width: 100%;
    max-width: 100%;
    height: auto;
`;

export const SliderBottom = styled.div`
    display: flex;
    position: absolute;
    bottom: 0;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${theme.space[3]}px ${theme.space[5]}px;
    z-index: 4;
`;

export const SliderBar = styled.div<{ active: boolean }>`
    flex-grow: 1;
    height: 2px;
    margin: ${theme.space[2]}px;
    background: ${({ active }) => (active ? theme.colors.grey7 : theme.colors.grey2)};
    cursor: pointer;
`;
